import React from 'react'
import PropTypes from 'prop-types'
import { links } from 'common/helpers'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import MainSection from 'components/_new/layout/MainSection/MainSection'
import { Button } from 'components/_new/controls'

import messages from './messages'
import s from './404.scss'

import image from './images/404.svg'


const Page404 = ({ err }) => (
  <WidthContainer>
    <MainSection>
      <div className={s.content}>
        <img className={s.image} src={image} alt="404 Not found" />
        <div className={s.info}>
          <FormattedMessage className={s.title} tag="div" {...messages.title} />
          <FormattedHTMLMessage className={s.desc} tag="div" {...messages.desc} />
          <Button className={s.button} color="brand" size="md" title={messages.buttonTitle} toOLD={links.home} />
        </div>
      </div>
      <div style={{ display: 'none' }} id="404-errorText" dangerouslySetInnerHTML={{ __html: err || 'Error: unknown' }} />
    </MainSection>
  </WidthContainer>
)

Page404.propTypes = {
  err: PropTypes.string,
}


export default Page404
